// extracted by mini-css-extract-plugin
export var inputContainer = "_p2-0";